<template>
    <div class="aba-cliente">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="columns">
                <div
                    class="column is-7"
                >
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-licenca-restricao"
                    />
                </div>
                <div
                    class="column is-2"
                >
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="40"
                    />
                </div>
                <div class="column is-3" v-if="permissaoVincular">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModal = !showModal"
                    >
                        {{ $t("vincular-prazo-pagamento") }}
                    </button>
                </div>
            </div>
            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assPrazoPagtoB2BEmpresa"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.label != 'excluir' ? $t(f.label) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.label == 'excluir'
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'situacao'">
                            <ButtonUpdateStatus 
                                :service="service"
                                :record="'prazo-pagamento'"
                                :item="props.row"
                                :identifier="props.row.descricao"
                                :canDelete="permissao.delete"
                                @loadData="carregarDados(pagination.currentPage)"
                            />
                        </div>
                        <div v-else-if="f.key == 'descricao'">
                            <router-link
                                :to="{
                                    name: 'ven-prazo-pagamento-edit',
                                    params: { id: props.row.idPrazoPagto },
                                }"
                            >
                                <pre>{{ props.row[f.key] }}</pre>
                            </router-link>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
            <b-modal :active.sync="showModal" @close="fecharModal">
                <div class="bg">
                    <PrazoPagamentoModal 
                        :idEmpresa="$route.params.id" 
                        @fecharModal="fecharModal"/>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import AssPrazoPagamentoB2BEmpresaService from '@/services/b2b/AssPrazoPagamentoB2BEmpresaService'; 
import PrazoPagamentoModal from '@/components/b2b/politica-comercial/modal/PrazoPagamentoModal.vue';
import ContainerLoader from "@/components/content/loader/ContainerLoader";
import ButtonUpdateStatus from '@/components/shared/buttons/ButtonUpdateStatus';

export default {
    components: {
        ContainerLoader,
        ButtonUpdateStatus,
        PrazoPagamentoModal
    },
    data() {
        return {
            assPrazoPagtoB2BEmpresa: [],
            fields: [
                { key: 'idb2b_assempresaprazopagto', label: 'codigo', width: '7.5%', sortable: true, sortFn: null },
                { key: 'descricao', label: 'descricao', width: null, sortable: true, sortFn: null },
                { key: 'situacao', label: 'situacao', width: 80, sortable: false, sortFn: null},
                { key: 'excluir', label: 'excluir', width: 20, sortable: false, sortFn: null}
            ],
            service: new AssPrazoPagamentoB2BEmpresaService(this.$http, this.$router),
            permissao: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacaoSelected: { id: 2, label: "todos" },
            situacaoSelect: [
                { id: 2, label: "todos" },
                { id: 1, label: "ativos" },
                { id: 0, label: "inativos" },
            ],
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'idb2b_assempresaprazopagto',
            order: 'asc',
            delete: null,
            showModal: false,

            permissaoVincular: false,
        }
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[
            this.pagination.optionStarted
        ];

        this.permissao = this.hasPermissionAccess(
            "b2b",
            "b2b-politica-comercial-edit"
        );
    

        this.permissaoVincular = this.permissao.create;
        
        if (!this.permissao.read){
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'prazo-pagamento' },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service.findAll(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.situacaoSelected.id,
                this.$route.params.idempresa,
                this.queryFilter
            )
            .then(this.mapItems)
            .then(mappedContent => {
                console.log(mappedContent)
                this.assPrazoPagtoB2BEmpresa = mappedContent;
                
                this.isEmpty = this.assPrazoPagtoB2BEmpresa.length <= 0;
            })
            .catch(e => {
                this.isEmpty = true;
                this.$root.showMessage('error', 'msg-erro-load');
                console.error('Erro ao carregar as tabelas de prazo de pagamento.');
            })
            .finally(_ => {
                this.isLoading = false;
                this.pagination.resetPagination = false;
            });
        },
        mapItems({ content, totalElements }) {
            this.pagination.totalRows = totalElements;

            return content.map(({ idB2BAssEmpresaPrazoPagamento: idb2b_assempresaprazopagto, ...rest }) => ({
                idb2b_assempresaprazopagto,
                ...rest
            }))
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSituacaoChanged(novaSituacao) {
            if (novaSituacao) {
                this.situacaoSelected = novaSituacao;
            } else {
                this.situacaoSelected = this.situacaoSelect[0];
            }
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        removePrompt() {
            this.delete = null;
        },
        fecharModal() {
            this.showModal = false;
            this.carregarDados();
        }
    },
}
</script>

<style lang="scss" scoped>
.aba-cliente {
    height: 100%;
    
    .botao-acao{
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.40rem;
        }
        .botao-acao{
            margin-top: 0;
        }
    }
}
</style>
